<dx-form
  #editFlightPreferenceFormRef
  class="social-form__form"
  [formData]="formData"
  [validationGroup]="validationGroup"
  labelMode="floating"
  [scrollingEnabled]="true"
  (onFieldDataChanged)="editFlightPreferenceFormRef?.instance?.validate()"
  [colCount]="12"
>
  <dxi-item
    [isRequired]="true"
    [dataField]="AirlinePreferenceKeys.airline"
    [editorType]="'dxSelectBox'"
    [label]="{ text: 'Preferred Airline' }"
    [colSpan]="12"
    [editorOptions]="{
      items: filteredAirlines,
      displayExpr: LookupKeys.description,
      valueExpr: LookupKeys.value,
      showClearButton: false,
      searchEnabled: true,
      onValueChanged: onPreferredAirlineValueChanged
    }"
  >
    <dxi-validation-rule type="required" [message]="'Airline is required'"></dxi-validation-rule>
  </dxi-item>

  <dxi-item
    [dataField]="AirlinePreferenceKeys.otherPreferredAirline"
    [editorType]="'dxTextBox'"
    [label]="{ text: 'Other Airline' }"
    [colSpan]="12"
    [editorOptions]="{disabled: formData?.[AirlinePreferenceKeys.airline] !== Airlines.Other}"
  >
  </dxi-item>

  <dxi-item
    [dataField]="AirlinePreferenceKeys.loyaltyNumber"
    [editorType]="'dxTextBox'"
    [label]="{ text: 'Loyalty Number' }"
    [editorOptions]="{ maxLength: 20}"
    [colSpan]="12"
  >
  </dxi-item>

  <dxi-item
    cssClass="ag-switch-with-label"
    [dataField]="AirlinePreferenceKeys.isFirstChoiceAirline"
    [label]="{ text: '1st Choice' }"
    editorType="dxSwitch"
    [editorOptions]="{ switchedOffText: 'No', switchedOnText: 'Yes', disabled: isFirstChoiceDisabled || formData?.isSecondChoiceAirline }"
    [alignItemLabels]="'left'"
    [colSpan]="6"
  >
  </dxi-item>

  <dxi-item
    cssClass="ag-switch-with-label"
    [dataField]="AirlinePreferenceKeys.isSecondChoiceAirline"
    [label]="{ text: '2nd Choice' }"
    editorType="dxSwitch"
    [editorOptions]="{ switchedOffText: 'No', switchedOnText: 'Yes', disabled: isSecondChoiceDisabled || formData?.isFirstChoiceAirline }"
    [alignItemLabels]="'left'"
    [colSpan]="6"
  >
  </dxi-item>
</dx-form>
